import { Dispatch } from "redux";
import { setOrganizationUsers, setOrganizationUsersLoading } from "@redux/actions/organization-users-actions";
import { FormattedAxnAdminUser } from "@idw-types/data/axn-admin-user";
import { AxnCompany, AxnIdentityProvider, AxnRelyingParty } from "@idw-types/data/reference-data/axn";
import { getAxnAdminUsersRequest } from "@requests/axnadmin-core";
import { formatAxnAdminUsers } from "@formatters/axn-admin-users/axn-admin-user-formatter";
import { logAndDisplayErrorModal } from "@utils/app-alert-util";
import { resources } from "@constants/hardcoded-strings";
import { AxnAdminAvailableUserProperty } from "@idw-types/data/axn-admin-available-user-property";
import { AxnAdminUserPropertyBundle } from "@idw-types/data/axn-admin-user-property-bundle";

export const getOrganizationUsersReduxRequest = (dispatch: Dispatch) => async (
    axnCompanies: Array<AxnCompany>,
    axnIdentityProviders: Array<AxnIdentityProvider>,
    axnAdminUserPropertyBundles: Array<AxnAdminUserPropertyBundle>,
    axnAdminAvailableUserOrganizationProperties: Array<AxnAdminAvailableUserProperty>,
    axnAdminAvailableUserRPProperties: Array<AxnAdminAvailableUserProperty>,
    axnRelyingParties: Array<AxnRelyingParty>
): Promise<Array<FormattedAxnAdminUser>> => {
    dispatch(setOrganizationUsersLoading(true));
    const { data, error } = await getAxnAdminUsersRequest();

    if (data?.axnAdminUsers) {
        const formattedAxnAdminUsers = formatAxnAdminUsers(
            data.axnAdminUsers,
            axnCompanies,
            axnIdentityProviders,
            axnAdminUserPropertyBundles,
            axnAdminAvailableUserOrganizationProperties,
            axnAdminAvailableUserRPProperties,
            axnRelyingParties
        );

        dispatch(setOrganizationUsers(formattedAxnAdminUsers));
        return formattedAxnAdminUsers;
    } else {
        if (error) {
            logAndDisplayErrorModal(
                dispatch,
                error,
                resources.requests.getOrganizationUsers.error.title,
                resources.requests.getOrganizationUsers.error.message
            );
        }
        dispatch(setOrganizationUsersLoading(false));
        return null;
    }
};